import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/shared/lib/classnames/cn';
import { classNames } from '../lib/classnames/classnames';
import type { VariantProps } from 'class-variance-authority';
const loaderVariants = cva('relative animate-spin', {
  variants: {
    size: {
      'xs': 'size-4',
      'sm': 'size-5',
      'base': 'size-6',
      'lg': 'size-8',
      'xl': 'size-10',
      '2xl': 'size-12',
      '3xl': 'size-14',
      '4xl': 'size-16'
    },
    color: {
      'primary': 'text-additionalBlue',
      'white': 'text-white',
      'secondary': 'text-additionalBlue',
      'secondary-error': 'text-additionalBlue',
      'secondary-main': 'text-additionalBlue',
      'outlined': 'text-additionalBlue',
      'text': 'text-additionalBlue'
    }
  },
  defaultVariants: {
    size: 'sm',
    color: 'primary'
  }
});
interface Props extends VariantProps<typeof loaderVariants> {
  className?: string;
}
export const Loader: React.FC<Props> = ({
  className,
  size,
  color
}) => {
  return <div role="status" className={classNames('', {}, [className])} data-sentry-component="Loader" data-sentry-source-file="loader.tsx">
      <svg className={cn(loaderVariants({
      color,
      size
    }))} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-sentry-element="svg" data-sentry-source-file="loader.tsx">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-sentry-element="circle" data-sentry-source-file="loader.tsx" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-sentry-element="path" data-sentry-source-file="loader.tsx" />
      </svg>
      <span className="sr-only">Loading...</span>
    </div>;
};